export const GET_API_KEY_SCOPES_REQUEST = 'GET_API_KEY_SCOPES_REQUEST';
export const GET_MY_API_KEYS_REQUEST = 'GET_MY_API_KEYS_REQUEST';
export const CREATE_API_KEY_REQUEST = 'CREATE_API_KEY_REQUEST';
export const REVOKE_MY_API_KEY_REQUEST = 'REVOKE_MY_API_KEY_REQUEST';
export const GET_ALL_API_KEYS_REQUEST = 'GET_ALL_API_KEYS_REQUEST';
export const GET_USER_API_KEYS_REQUEST = 'GET_USER_API_KEYS_REQUEST';
export const REVOKE_USER_API_KEY_REQUEST = 'REVOKE_USER_API_KEY_REQUEST';
export const DELETE_USER_API_KEY_REQUEST = 'DELETE_USER_API_KEY_REQUEST';

export const getApiKeyScopes = (callback) => ({
    type: GET_API_KEY_SCOPES_REQUEST,
    payload: { callback },
});

export const getMyApiKeys = (callback) => ({
    type: GET_MY_API_KEYS_REQUEST,
    payload: { callback },
});

export const createApiKey = (data, callback) => ({
    type: CREATE_API_KEY_REQUEST,
    payload: { data, callback },
});

export const revokeMyApiKey = (keyId, callback) => ({
    type: REVOKE_MY_API_KEY_REQUEST,
    payload: { keyId, callback },
});

export const getAllApiKeys = (params, callback) => ({
    type: GET_ALL_API_KEYS_REQUEST,
    payload: { params, callback },
});

export const getUserApiKeys = (userId, callback) => ({
    type: GET_USER_API_KEYS_REQUEST,
    payload: { userId, callback },
});

export const revokeUserApiKey = (userId, keyId, callback) => ({
    type: REVOKE_USER_API_KEY_REQUEST,
    payload: { userId, keyId, callback },
});

export const deleteUserApiKey = (userId, keyId, callback) => ({
    type: DELETE_USER_API_KEY_REQUEST,
    payload: { userId, keyId, callback },
});
